"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const prop_types_1 = __importDefault(require("prop-types"));
const get_css_1 = __importDefault(require("../get-css"));
exports.propTypes = {
    transform: prop_types_1.default.string,
    transformOrigin: prop_types_1.default.string
};
exports.propAliases = {};
exports.propValidators = {};
const transform = {
    className: 'tfrm',
    cssName: 'transform',
    jsName: 'transform',
    complexValue: true
};
const transformOrigin = {
    className: 'tfrm-orgn',
    cssName: 'transform-origin',
    jsName: 'transformOrigin',
    complexValue: true
};
exports.propEnhancers = {
    transform: (value) => get_css_1.default(transform, value),
    transformOrigin: (value) => get_css_1.default(transformOrigin, value)
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHJhbnNmb3JtLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2VuaGFuY2Vycy90cmFuc2Zvcm0udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSw0REFBa0M7QUFDbEMseURBQStCO0FBR2xCLFFBQUEsU0FBUyxHQUFxQjtJQUN6QyxTQUFTLEVBQUUsb0JBQVMsQ0FBQyxNQUFNO0lBQzNCLGVBQWUsRUFBRSxvQkFBUyxDQUFDLE1BQU07Q0FDbEMsQ0FBQTtBQUVZLFFBQUEsV0FBVyxHQUFnQixFQUFFLENBQUE7QUFFN0IsUUFBQSxjQUFjLEdBQW1CLEVBQUUsQ0FBQTtBQUVoRCxNQUFNLFNBQVMsR0FBRztJQUNoQixTQUFTLEVBQUUsTUFBTTtJQUNqQixPQUFPLEVBQUUsV0FBVztJQUNwQixNQUFNLEVBQUUsV0FBVztJQUNuQixZQUFZLEVBQUUsSUFBSTtDQUNuQixDQUFBO0FBQ0QsTUFBTSxlQUFlLEdBQUc7SUFDdEIsU0FBUyxFQUFFLFdBQVc7SUFDdEIsT0FBTyxFQUFFLGtCQUFrQjtJQUMzQixNQUFNLEVBQUUsaUJBQWlCO0lBQ3pCLFlBQVksRUFBRSxJQUFJO0NBQ25CLENBQUE7QUFFWSxRQUFBLGFBQWEsR0FBa0I7SUFDMUMsU0FBUyxFQUFFLENBQUMsS0FBNEIsRUFBRSxFQUFFLENBQUMsaUJBQU0sQ0FBQyxTQUFTLEVBQUUsS0FBSyxDQUFDO0lBQ3JFLGVBQWUsRUFBRSxDQUFDLEtBQTRCLEVBQUUsRUFBRSxDQUFDLGlCQUFNLENBQUMsZUFBZSxFQUFFLEtBQUssQ0FBQztDQUNsRixDQUFBIn0=